import { WalkInConsultScheduleRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { WalkInConsultTimeslotResponse } from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getSchedule = (practiceId: string): Promise<WalkInConsultTimeslotResponse[]> => {
  return axiosAuth({
    url: `/practices/${practiceId}/walkinconsult/schedule`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const updateSchedule = (practiceId: string, req: WalkInConsultScheduleRequest): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/walkinconsult/schedule`,
    method: "put",
    data: req,
  }).then(() => undefined)
}
